import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import Organization from "@/pages/Organization";
import Checkout from "@/pages/Checkout";
import Confirmation from "@/pages/Confirmation";
import Voorwaarden from "@/pages/Voorwaarden";
import Privacybeleid from "@/pages/Privacybeleid";
import WaitlistUnsubscribe from "@/pages/WaitlistUnsubscribe";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminForgotPassword from "@/pages/admin/AdminForgotPassword";
import AdminResetPassword from "@/pages/admin/AdminResetPassword";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminHome from "@/pages/admin/AdminHome";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminEvents from "@/pages/admin/AdminEvents";
import AdminEventForm from "@/pages/admin/AdminEventForm";
import { AdminReportsOverview, AdminReportDetail } from "@/pages/admin/AdminReports";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminOrganizations from "@/pages/admin/AdminOrganizations";
import AdminScan from "@/pages/admin/AdminScan";
import AdminPresence from "@/pages/admin/AdminPresence";
import AdminLiveFlow from "@/pages/admin/AdminLiveFlow";
import AdminTrafficControllers from "@/pages/admin/AdminTrafficControllers";
import AdminTrafficChat from "@/pages/admin/AdminTrafficChat";
import { AdminIncidentsOverview, AdminIncidentDetail } from "@/pages/admin/AdminIncidents";
import ProtectedRoute from "@/components/admin/ProtectedRoute";
import { AuthProvider } from "@/lib/auth";

function PublicShell({ children }) {
  return (
    <>
      <Navbar />
      <main data-testid="app-main">{children}</main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="min-h-screen bg-svj-bg text-white font-sans">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<PublicShell><Home /></PublicShell>} />
            <Route path="/events" element={<PublicShell><Events /></PublicShell>} />
            <Route path="/events/:slug" element={<PublicShell><EventDetail /></PublicShell>} />
            <Route path="/organisatie/:slug" element={<PublicShell><Organization /></PublicShell>} />
            <Route path="/checkout" element={<PublicShell><Checkout /></PublicShell>} />
            <Route path="/order/:orderId" element={<PublicShell><Confirmation /></PublicShell>} />
            <Route path="/voorwaarden" element={<PublicShell><Voorwaarden /></PublicShell>} />
            <Route path="/privacybeleid" element={<PublicShell><Privacybeleid /></PublicShell>} />
            <Route path="/waitlist/unsubscribe/:token" element={<PublicShell><WaitlistUnsubscribe /></PublicShell>} />

            {/* Admin */}
            <Route path="/admin/login" element={<PublicShell><AdminLogin /></PublicShell>} />
            <Route path="/admin/forgot-password" element={<PublicShell><AdminForgotPassword /></PublicShell>} />
            <Route path="/admin/reset-password" element={<PublicShell><AdminResetPassword /></PublicShell>} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<ProtectedRoute blockScanner blockTrafficCoordinator><AdminDashboard /></ProtectedRoute>} />
              <Route path="events" element={<ProtectedRoute blockScanner blockTrafficCoordinator><AdminEvents /></ProtectedRoute>} />
              <Route path="events/new" element={<ProtectedRoute blockScanner blockTrafficCoordinator><AdminEventForm /></ProtectedRoute>} />
              <Route path="events/:eventId" element={<ProtectedRoute blockScanner blockTrafficCoordinator><AdminEventForm /></ProtectedRoute>} />
              <Route path="reports" element={<ProtectedRoute blockScanner blockTrafficCoordinator><AdminReportsOverview /></ProtectedRoute>} />
              <Route path="reports/:eventId" element={<ProtectedRoute blockScanner blockTrafficCoordinator><AdminReportDetail /></ProtectedRoute>} />
              <Route path="scan" element={<AdminScan />} />
              <Route path="presence" element={<ProtectedRoute blockScanner blockTrafficCoordinator><AdminPresence /></ProtectedRoute>} />
              <Route path="live-flow" element={<ProtectedRoute blockScanner><AdminLiveFlow /></ProtectedRoute>} />
              <Route path="traffic-control" element={<ProtectedRoute blockScanner><AdminTrafficControllers /></ProtectedRoute>} />
              <Route path="traffic-chat" element={<ProtectedRoute blockScanner><AdminTrafficChat /></ProtectedRoute>} />
              <Route path="incidents" element={<ProtectedRoute blockScanner><AdminIncidentsOverview /></ProtectedRoute>} />
              <Route path="incidents/:incidentId" element={<ProtectedRoute blockScanner><AdminIncidentDetail /></ProtectedRoute>} />
              <Route
                path="users"
                element={
                  <ProtectedRoute requireSuperadmin allowEventUser>
                    <AdminUsers />
                  </ProtectedRoute>
                }
              />
              <Route
                path="organizations"
                element={
                  <ProtectedRoute requireSuperadmin>
                    <AdminOrganizations />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Routes>
          <Toaster
            theme="dark"
            position="top-right"
            toastOptions={{
              style: { background: "#162235", color: "#fff", border: "1px solid #1e3050" },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
